import { toast } from "react-hot-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useToggleVaccine = () => {
  const queryClient = useQueryClient();
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async (vaccine) => {
      const axiosInstance = createAxiosInstance();
      return axiosInstance.post(`${tenantVal}/immunisation`, vaccine);
    },
    onSuccess: (_, vaccine) => {
      toast.success(`Vaccine ${vaccine.disabled ? "disabled" : "enabled"} successfully`);
      queryClient.invalidateQueries({ queryKey: ["settingsVaccines", tenantVal] });
    },
    onError: (error) => {
      toast.error(error.message || "An error occurred");
    },
  });
};
